import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
  "new_name": Joi.string().allow(''),
  "start_datetime": Joi.string().allow(''),
  "end_datetime": Joi.string().allow(''),
  "teacher_id_list": Joi.array().items(Joi.number().integer()),
  "student_id_list": Joi.array().items(Joi.number().integer()),
  "classroom_id": Joi.number().integer().allow(''),
  "calendar_color": Joi.string().allow(''),
  "note": Joi.string().allow(''),
});

export default function updateLessonWithTime(lessonId, lessonInfo) {

  if(!lessonId){
    throw 'missing lesson(event) ID'
  }

  let validateResult = Joi.validate(lessonInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...lessonInfo,
  }

  console.log(toServer);

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_lss_with_time/${lessonId}/`,
		'method': 'PUT',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/lesson/updateLessonWithTime.js